import { Cancel } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get, Set } from "../../../../../Request";

export const useRenewall = () => {
  const [loading, setLoading] = useState(true);
  const [btnloading, setBtnloading] = useState(false);
  const [data, setData] = useState({});
  const [cansel, setCansel] = useState([]);
  const { trackingcodeorder } = useParams();
  const [payType, setPayType] = useState("gateway");
  const [balance, setBalance] = useState("loading");

  useEffect(() => {
    getBalance();
  }, [])

  const renewwall = async () => {
    await Get({
      url: "/order/renewal_contractual_reserve",
      data: {
        trackingcodeorder: trackingcodeorder,
      },
    }).then((response) => {
      setData(response);
      setLoading(false);
    });
  };

  const getBalance = async () => {
    const data = await Get({ url: "/wallet/show" });
    setBalance(data.wallet.amount)
  };

  const pay = async (trac) => {
    setBtnloading(true);
    Get({
      url: "/order/pay_contractual_reserve",
      data: { cansel_times: cansel, trackingcodeorder: trackingcodeorder, type_payment: payType },
      stat: true
    }).then((response) => {
      console.log(response);
      if (response?.data?.url) {
        window.location.replace(response?.data?.url);
      }
      setBtnloading(false);
    });
  };
  return {
    renewwall,
    loading,
    data,
    cansel,
    setCansel,
    pay,
    btnloading,
    setPayType,
    payType,
    balance
  };
};
